import axios from "axios";
import dayjs from "dayjs";  

export const fetchMachineSensorData = async (machineId, fromDate, toDate) => {
        let formattedFromDate= dayjs(fromDate).format("YYYY-MM-DDTHH:mm:ss.SSS");
        let formattedToDate = dayjs(toDate).format("YYYY-MM-DDTHH:mm:ss.SSS");
    const response = await axios.get("api/sensordata/"+ machineId + "?fromDate="+ formattedFromDate + "&toDate="+ formattedToDate );
    const sensorData = response.data;
    return sensorData;
}